import { getAdminOrganisationByOrganisationIdGroupByGroupIdUser } from '@modv/sdk'

const state = {
  users: [],
  adminUsers: []
}
const getters = {}
const mutations = {
  GET_USERS: (state, res) => {
    state.adminUsers = res.data.adminUsers
    state.users = res.data.users
  },
  ADD_USER: (state, res) => {
    state.users.push(res)
    state.total++
  },
  REMOVE_USER: (state, res) => {
    state.users = state.users.filter((x) => x._id !== res.userId)
    state.total--
  },
  ADD_ADMIN_USER: (state, res) => {
    state.adminUsers.push(res)
    state.total++
  },
  REMOVE_ADMIN_USER: (state, res) => {
    state.adminUsers = state.adminUsers.filter((x) => x._id !== res.userId)
    state.total--
  },
  REMOVE_INVITED_USER: (state, res) => {
    state
  }
}
const actions = {
  async getUsers({ commit }, params) {
    commit(
      'GET_USERS',
      await getAdminOrganisationByOrganisationIdGroupByGroupIdUser({
        organisationId: params.organisationId,
        groupId: params.groupId
      })
    )
  },
  addUser({ commit }, params) {
    commit('ADD_USER', {
      group: params.data.data
    })
  },
  removeUser({ commit }, params) {
    commit('REMOVE_USER', params.userId)
  },
  removeInvited({ commit }, params) {
    commit('REMOVE_INVITED_USER', params.userId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
